import {
  Tent,
  Compass,
  Anchor,
  Binoculars,
  FlowerLotus,
  TreeEvergreen,
  Star,
} from "@phosphor-icons/react";
import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { ArrowRight } from "@phosphor-icons/react";
import { SectionEyebrow, interactiveCardSx, warmGlowBackground } from "@scoutingops/ui";

const HUB_URL = (import.meta.env.VITE_HUB_URL ?? "https://scoutingops.com") as string;

const programs = [
  { icon: Compass, label: "Troops" },
  { icon: Tent, label: "Packs" },
  { icon: Binoculars, label: "Crews" },
  { icon: Star, label: "Clubs" },
];

export default function SupportedProgramsSection() {
  return (
    <Box
      component="section"
      sx={{
        py: { xs: 10, md: 14 },
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          background: warmGlowBackground,
          pointerEvents: "none",
        },
      }}
    >
      <Container maxWidth="lg" sx={{ position: "relative" }}>
        <Stack
          spacing={2}
          sx={{ alignItems: "center", textAlign: "center", mb: 7 }}
        >
          <SectionEyebrow>One Platform, Every Program</SectionEyebrow>
          <Typography variant="h3" sx={{ fontWeight: 800, maxWidth: 700 }}>
            Built for the way youth programs actually work
          </Typography>
          <Typography
            color="text.secondary"
            sx={{ maxWidth: 660, fontSize: { xs: "1rem", md: "1.1rem" } }}
          >
            Pick your program. We pre-fill your site with the right content,
            structure, and terminology — so it feels like it was made for you,
            because it was.
          </Typography>
        </Stack>

        <Box
          sx={{
            display: "grid",
            gap: 2,
            maxWidth: 900,
            mx: "auto",
            gridTemplateColumns: {
              xs: "repeat(2,1fr)",
              sm: "repeat(3,1fr)",
              md: "repeat(4,1fr)",
            },
          }}
        >
          {programs.map((p) => (
            <Stack
              key={p.label}
              spacing={1}
              sx={[
                {
                  alignItems: "center",
                  p: 3,
                  borderRadius: 3,
                  border: "1px solid",
                  borderColor: "divider",
                  bgcolor: "background.paper",
                  cursor: "default",
                },
                interactiveCardSx,
              ]}
            >
              <Box
                className="brand-cardIcon"
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: 2,
                  display: "grid",
                  placeItems: "center",
                  bgcolor: "action.hover",
                  color: "primary.main",
                }}
              >
                <p.icon size={20} weight="duotone" />
              </Box>
              <Typography
                sx={{
                  fontSize: "0.85rem",
                  fontWeight: 700,
                  textAlign: "center",
                }}
              >
                {p.label}
              </Typography>
            </Stack>
          ))}
        </Box>

        <Stack sx={{ alignItems: "center", mt: 5 }}>
          <Typography color="text.secondary" sx={{ fontSize: "0.9rem", mb: 2 }}>
            More programs being added. Don&apos;t see yours?
          </Typography>
          <Button
            component="a"
            href={`${HUB_URL}/auth/waitlist`}
            variant="outlined"
            size="small"
            endIcon={<ArrowRight size={14} />}
          >
            Request Your Program
          </Button>
        </Stack>
      </Container>
    </Box>
  );
}
